var map = {
	"./bar-chart.svg": 18106,
	"./chart.svg": 20354,
	"./folder.svg": 34790,
	"./link.svg": 56086,
	"./locked.svg": 3732,
	"./magic-wand.svg": 41878,
	"./voltage.svg": 24176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20862;